<div class="relative p-4 flex flex-col gap-4">
  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Coordonnées du représentant</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right whitespace-nowrap">Nom / RS</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_NomR"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Prénom</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_PrenomR"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Adresse</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Adresse1R"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Complément</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_Adresse2R"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right">CP, Ville</td>
        <td class="flex gap-1">
          <mat-form-field appearance="outline" class="w-20">
            <input
              matInput
              [maxlengthinput]="6"
              [(ngModel)]="actionnaire.actionnaire_CPR"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_VilleR"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Pays</td>
        <td>
          <select-pays
            [(ngModel)]="actionnaire.pays_IDR"
            [selectNo]="true"
            [enableCreate]="true"
            [enableEdit]="true"
          ></select-pays>
        </td>
      </tr>
    </table>
  </mat-card>
  <!--<tr>
      <td colspan="2">
        <div class="flex items-center gap-2 my-4">
          <div
            class="flex-1 border-b border-[var(--secondary)] border-dotted"
          ></div>
          <h4 class="important-title dark-txt text-base">
            Coordonnées bancaires du représentant
          </h4>
          <div
            class="flex-1 border-b border-[var(--secondary)] border-dotted"
          ></div>
        </div>
      </td>
    </tr>
    <tr>
      <td class="text-right items-start">Enseigne bancaire</td>
      <td>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput [maxlengthinput]="50" placeholder="AUCUNE IDEE" />
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td class="text-right items-start">Banque</td>
      <td>
        <select-banque
          [(ngModel)]="actionnaire.actionnaire_Banque_IDR"
          [selectNo]="true"
          [enableCreate]="true"
          [enableEdit]="true"
        ></select-banque>
      </td>
    </tr>
    <tr>
      <td class="text-right items-start">Libellé du compte</td>
      <td>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [maxlengthinput]="50"
            [(ngModel)]="actionnaire.actionnaire_Banque_LIBR"
          />
        </mat-form-field>
      </td>
    </tr>-->
  <mat-card class="p-4 bg-[var(--main-card)]">
    <h6 class="font-semibold mb-4">Communication du représentant</h6>
    <table class="w-full no-margin-field-bottom form-table">
      <tr>
        <td class="text-right items-start">Téléphones</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_Tel1R"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_Tel2R"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right items-start">Fax, Mobile</td>
        <td class="flex items-center gap-1">
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_FaxR"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [maxlengthinput]="20"
              [(ngModel)]="actionnaire.actionnaire_MobileR"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td class="text-right whitespace-nowrap">Email</td>
        <td>
          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [maxlengthinput]="50"
              [(ngModel)]="actionnaire.actionnaire_EmailR"
            />
          </mat-form-field>
        </td>
      </tr>
    </table>
  </mat-card>
</div>
